enum DrmType {
    FAIRPLAY = 'FAIRPLAY',
    NONE = 'NONE',
    PLAYREADY = 'PLAYREADY',
    WIDEVINE = 'WIDEVINE'
}

export default DrmType;